import modal from './modal.js'
export default function installPlugins(app) {
    // 模态框对象
    app.config.globalProperties.$modal = modal
}
